"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDays = {
    1: 'Пн',
    2: 'Вт',
    3: 'Ср',
    4: 'Чт',
    5: 'Пт',
    6: 'Сб',
    7: 'Вс',
};
//# sourceMappingURL=WeekDays.js.map